import { render, staticRenderFns } from "./package-payment-table.vue?vue&type=template&id=2c7b3a42"
import script from "./package-payment-table.vue?vue&type=script&lang=js"
export * from "./package-payment-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports